import { render, staticRenderFns } from "./Opportunity-card.vue?vue&type=template&id=1b7009cc"
import script from "./Opportunity-card.vue?vue&type=script&lang=js"
export * from "./Opportunity-card.vue?vue&type=script&lang=js"
import style0 from "./Opportunity-card.vue?vue&type=style&index=0&id=1b7009cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports